export default __webpack_public_path__ + "static/media/08_pull_back.c6922716.jpg";